// extracted by mini-css-extract-plugin
module.exports = {"root":"_3KIgkbPOGPQ95f00ZvKdOK"};